// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-2bN-B7ZinnY_FsF7HtdLC-","light":"light-CArxKKlqINe3ixEsEqpct","dark":"dark-2L2G2WHara3bywWVvIvJzv"};